import React, { Component } from "react";
import { connect } from "react-redux";
import "./content.scss";
import queryIcon from "../../../assets/svg/queryBlue.svg";
import { Link } from "react-router-dom";
import qbImg from "../../../assets/query-builder.png";
import { Dimmer, Loader } from "semantic-ui-react";
import { setActiveModule } from "../../../actions/sideBarActions";

class CreateQuery extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    componentWillUnmount() {}
    // handleCreateQueryButton = () => {
    //     localStorage.setItem("activeModule", "Listening");
    //     this.props.setActiveModule("Listening");
    // };

    handleCreateQueryButton = () => {
        localStorage.setItem("activeModule", "Listening");
        this.props.setModule("Listening");
    };
    render() {
        return (
            <>
                <div className="gs_content">
                    <div className="left_content">
                        <div className="gs_header">
                            <img src={queryIcon} color="#268af6" className="icon_content" />
                            <span className="content_title">Create Your Own Query</span>
                        </div>
                        <div className="text_content">
                            <p>{`Sometimes, you need to track conversations on an ongoing basis and it is not enough to just run a one time search.`}</p>
                            <p>{`It is easy-peasy with Radarr :-)`} </p>
                            <p>{`Use the Query Builder to create queries and organize them under topics based on keywords you entered.  Use the translate tool to configure keywords in other languages.`}</p>
                            <p>{`Not sure what data will come up for the query?  View a Sample of the data before you save the Query.`} </p>
                            <p>{`Need historical data?  No problem!`}</p>
                            <p>{`We also have a beginner mode to get you started.`}</p>
                        </div>
                        <Link to="/data">
                            <button className="gs_link" onClick={this.handleCreateQueryButton}>
                                Create Query
                            </button>
                        </Link>
                    </div>
                    <div className="right_content">
                        <div id="gs_loader">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                        <iframe
                            width="320px"
                            height="200px"
                            src="https://www.youtube.com/embed/exAhk_CHzg0"
                            title=""
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                            allowFullScreen
                            onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                            className="content_video"></iframe>
                        {/* <img className="content-img" src={qbImg} width="350px" height="200px" /> */}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        setModule: (data) => dispatch(setActiveModule(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateQuery);
